import API from "./api";
// ! Category

export const fetchCategory = () =>
  API.get("/api/v1/company-category?asset_pool[ne]=INTANGIBLES");

export const CompanyCategory = (postData) =>
  API.post("/api/v1/company-category", postData);

// ! Location

export const fetchLocations = () => API.get("/api/v1/company-location");

export const CompanyLocation = (postData) =>
  API.post("/api/v1/company-location", postData);

// ! Assets

export const fetchAssets = () =>
  API.get("/api/v1/company-assets/tangibleAssets/tangible-section");
export const fetchIntangibleAssets = () =>
  API.get("/api/v1/company-assets/intangibleAssets/intangible-section");
// "/api/v1/company-assets/get-asset-by-code/code?disposed=true"

// sign in a new user
export const signIn = (formData) => API.post("/api/v1/users/login", formData);
// the user already signed in to another app, if any (shared login cookie)
export const fetchSignedInUser = () => API.get("/api/v1/users/me");
// ends the shared login for every app in this browser
export const signOut = () => API.post("/api/v1/users/logout");
// Sign up a new user
export const signup = (formData) => API.post("/api/v1/users/signup", formData);

// Security
// forgot password
export const forgotPassword = (postData) =>
  API.post("/api/v1/users/forgotPassword", postData);

// reset password
export const resetPassword = (token, postData) =>
  API.patch(`/api/v1/users/resetPassword/${token}`, postData);

// reset password
export const changePassword = (postData) =>
  API.patch(`/api/v1/users/updateMypassword`, postData);

export const getUsers = () => API.get("/api/v1/users");

// ! Update users information and delete users
export const updateUser = (id, postData) =>
  API.patch(`/api/v1/users/update-user/info/${id}`, postData);
export const deleteUser = (id) =>
  API.delete(`/api/v1/users/delete-selected-user/info/${id}`);

//! Investment
export const getInvestments = () =>
  API.get("/api/v1/investment?rate_type[ne]=undefined rate");

export const getIndividualInvestments = () =>
  API.get("/api/v1/individual-investment?rate_type[ne]=undefined rate");

export const getImpairedInvestments = () =>
  API.get("/api/v1/investment?impaired[eq]=true");
export const getRedeemedInvestments = () =>
  API.get("/api/v1/investment?redeemed[eq]=true");

export const createInvestment = (postData) =>
  API.post("/api/v1/investment", postData);
export const createIndividualInvestment = (postData) =>
  API.post("/api/v1/individual-investment", postData);

export const updateInvestment = (id, postData) =>
  API.patch(`/api/v1/investment/${id}`, postData);
export const updateIndividualInvestment = (id, postData) =>
  API.patch(`/api/v1/individual-investment/${id}`, postData);

export const deleteInvestment = (id) => API.delete(`/api/v1/investment/${id}`);
export const deleteIndividualInvestment = (id) =>
  API.delete(`/api/v1/individual-investment/${id}`);
export const approveInvestment = (id) =>
  API.patch(`/api/v1/investment/${id}/approve`);
export const returnInvestment = (id, reason) =>
  API.patch(`/api/v1/investment/${id}/return`, { reason });

// regulator
export const getRegulator = () => API.get("/api/v1/investment-regulator");
export const createRegulator = (postData) =>
  API.post("/api/v1/investment-regulator", postData);
export const deleteRegulator = (id) =>
  API.delete(`/api/v1/investment-regulator/${id}`);

// types
export const getInvestmentTypes = () => API.get("/api/v1/investment-type");
export const createInvestmentTypes = (postData) =>
  API.post("/api/v1/investment-type", postData);
export const deleteInvestmentTypes = (id) =>
  API.delete(`/api/v1/investment-type/${id}`);

// institution
export const getInstitution = () => API.get("/api/v1/investment-institution");
export const createInstitution = (postData) =>
  API.post("/api/v1/investment-institution", postData);
export const deleteInstitution = (id) =>
  API.delete(`/api/v1/investment-institution/${id}`);

export const newInvestments = () =>
  API.get("/api/v1/investment?approved[eq]=false");
export const newIndividualInvestments = () =>
  API.get("/api/v1/individual-investment?approved[eq]=false");

export const approvedInvestments = () =>
  API.get("/api/v1/investment?approved[eq]=true&rate_type[ne]=undefined rate");
export const approvedIndividualInvestments = () =>
  API.get(
    "/api/v1/individual-investment?approved[eq]=true&rate_type[ne]=undefined rate",
  );

export const yearStats = () => API.get("/api/v1/investment/year-group/stats");
export const monthStats = () => API.get("/api/v1/investment/month-group/stats");

// undefined investments

export const getUndefinedInvestments = () =>
  API.get("/api/v1/investment?rate_type=undefined rate");

export const getApprovedUndefinedInvestments = () =>
  API.get("/api/v1/investment/undefined-rate/report");

export const getInvestmentInstitutionStats = () =>
  API.get("/api/v1/investment/institution-group/stats");

// ! impaired investment

// Authenticator-app sign-in: the code step after a correct password
export const twoFactorLoginVerify = (postData) =>
  API.post("/api/v1/users/two-factor/login/verify", postData);
export const twoFactorLoginSetup = (postData) =>
  API.post("/api/v1/users/two-factor/login/setup", postData);
export const twoFactorLoginSetupConfirm = (postData) =>
  API.post("/api/v1/users/two-factor/login/setup/confirm", postData);
// ...and the signed-in user's own authenticator app
export const getMyTwoFactor = () => API.get("/api/v1/users/two-factor/me");
export const startMyTwoFactorSetup = () =>
  API.post("/api/v1/users/two-factor/me/setup");
export const enableMyTwoFactor = (code) =>
  API.post("/api/v1/users/two-factor/me/enable", { code });
export const disableMyTwoFactor = (postData) =>
  API.post("/api/v1/users/two-factor/me/disable", postData);
export const newMyBackupCodes = (code) =>
  API.post("/api/v1/users/two-factor/me/backup-codes", { code });
